"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApis = exports.isMockRequest = void 0;
const CONSTANTS = __importStar(require("../common/constants"));
const cookies_manager_1 = require("../common/cookies_manager");
const mocked_apis_1 = require("./mocks/mocked_apis");
const service_apis_1 = require("./service_apis");
function isMockRequest() {
    return CONSTANTS.MOCKED_SERVICE === cookies_manager_1.CookiesManager.getCookie(CONSTANTS.COOKIE_EDM_MOCK_TYPE);
}
exports.isMockRequest = isMockRequest;
function getApis() {
    return isMockRequest() ? mocked_apis_1.MockedApisInstance : service_apis_1.ServiceApisInstance;
}
exports.getApis = getApis;
